<form #closeForm="ngForm" (ngSubmit)="close()" novalidate>
  <h2 mat-dialog-title>
    Deny request for: <strong *ngIf="approval?.value">{{ approval.approvalColumn | titlecase }} → {{ approval.value }} </strong>
  </h2>
  <mat-dialog-content>
    <div class="pairs">
      <div class="row" *ngIf="approval.recipient">
        <span class="label">Recipient:</span>
        <span class="value">{{ approval.recipient!.enisNumber }}</span>
        <span class="flex">{{ approval.recipient.firstName || "" }}</span>
      </div>
    </div>

    <ng-container>
      <mat-form-field>
        <input matInput name="otherReason" type="text" required placeholder="Reason for denying request" [(ngModel)]="otherReason" #reasonCtrl="ngModel" />
        <mat-error *ngIf="reasonCtrl.hasError('required')"> Please enter a reason for denying the request. </mat-error>
      </mat-form-field>
    </ng-container>
    <ng-template #willclose>
      <i>Are you sure you want to deny this request?</i>
    </ng-template>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="spacer"></div>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button type="submit" [disabled]="!closeForm.valid">Deny</button>
  </mat-dialog-actions>
</form>
